export function isValidPESEL(pesel) {
  // Return bool - True if provided value is a valid PESEL
  // PESEL - Polish personal identification number

  if (typeof pesel !== "string") return false;

  // check if pesel contains exactly 11 digits and no other text
  let digits = parseInt(pesel).toString();
  if (digits.length !== pesel.length || digits.length !== 11) return false;

  // check if provided birthday is a real date
  // this may be imperfect because it relies on the js Date API, backend comes with more reliable validation
  let centuries = [1900, 2000, 2100, 2200, 1800];

  let d = new Date(0);
  let year, month, day;
  [year, month, day] = [
    +pesel.substring(0, 2),
    +pesel.substring(2, 4),
    +pesel.substring(4, 6)
  ];
  d.setFullYear(
    year + centuries[Math.floor(month / 20)],
    (month % 20) - 1,
    day
  );
  let leadingZero = value => ("0" + value).slice(-2);
  if (
    d
      .getFullYear()
      .toString()
      .substring(2) +
      leadingZero(d.getMonth() + 1) +
      leadingZero(d.getDate()) !==
    pesel.substring(0, 6)
  ) {
    return false;
  }

  // calculate checksum
  let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
  let sum = 0;
  let controlNumber = parseInt(pesel.substring(10, 11));

  for (let i = 0; i < weight.length; i++) {
    sum += parseInt(pesel.substring(i, i + 1)) * weight[i];
  }
  sum = sum % 10;
  return (10 - sum) % 10 === controlNumber;
}
